<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { PublicGameSession } from '../api/types';
  import { scale } from 'svelte/transition';
  import Button from '$components/ui/button.svelte';
  import { t } from '$lib/i18n';

  export let sharedGameSession: PublicGameSession;

  const dispatch = createEventDispatcher<{ start: undefined }>();
</script>

<div
  transition:scale={{ start: 0.5, duration: 300 }}
  class="pointer-events-auto absolute z-20 top-1/2 translate-y-10 left-3 right-3 max-w-[320px] mx-auto"
>
  <div class="bg-highlight rounded-md p-4 text-center mx-auto gap-3 shadow-game">
    {#if sharedGameSession}
      <p class="text-6xl text-accent font-semibold">{sharedGameSession.score}</p>
      <p class="mt-2">{$t('game.start.title.shared')}</p>
      <div class="mt-1 text-primary/40 leading-relaxed">
        <p>{$t('game.start.help.line-one')}</p>
        <p>{$t('game.start.help.line-two')}</p>
      </div>
    {:else}
      <p>{$t('game.start.title')}</p>
      <div class="mt-1 text-primary/40 leading-relaxed">
        <p>{$t('game.start.help.line-one')}</p>
        <p>{$t('game.start.help.line-two')}</p>
      </div>
    {/if}

    <Button
      name="start"
      class="w-full mt-4"
      on:click={() => {
        dispatch('start');
      }}>{$t('game.start.button')}</Button
    >
  </div>
</div>
